export const summaryNotesContinueBtnDataSet = { cy: 'SummaryNotes-continue-btn' };
export const skipSummaryNotes = { cy: 'SummaryNotes-skip-btn' };
